import React from "react";
import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./WeddingInfo.css"; // Copy and modify from HangerInfo.css
import weddingImg from "../../assets/serv-7.jpg"; // Add your wedding image

const WeddingInfo = () => {
  return (
    <section className="info">
      <Container className="company-info">
        <Row className="g-4 align-items-start">
          <Col lg={8} className="slide-in-left">
            <h1 className="text-primary2 fw-bold mb-4 text-center text-lg-start">Wedding Management</h1>
            <Row className="align-items-center">
              <Col xs={12} md={6}>
                <img
                  src={weddingImg}
                  alt="Wedding Setup"
                  className="img-fluid mb-3 company-image"
                />
              </Col>
              <Col xs={12} md={6} className="text-white">
                <h4 className="text-white mt-4 mb-3 text-center text-md-start">Our Wedding Services</h4>
                <ul className="event-services-list ps-3">
                  <li>Venue Selection & Decoration</li>
                  <li>Themed Stage & Mandap Setup</li>
                  <li>Lighting & Floral Arrangements</li>
                  <li>Bridal & Groom Entry Concepts</li>
                  <li>Guest Hospitality & Coordination</li>
                  <li>Photography & Cinematic Coverage</li>
                  <li>Catering & Custom Menus</li>
                  <li>Complete Wedding Planning Solutions</li>
                </ul>
              </Col>
            </Row>
            <p className="text-white mt-3">
              Zarinova Weddings ensures your special day is truly unforgettable. From intimate ceremonies to grand receptions, our expert team manages everything from concept to execution — with elegance, precision, and love. We bring your dream wedding to life, with seamless coordination and impeccable attention to detail.
            </p>
          </Col>

          <Col lg={4} className="slide-in-right">
            <Card className="get-in-touch-card mt-4">
              <Card.Body>
                <h5 className="fw-bold text-white text-center">GET IN TOUCH</h5>
                <p className="small text-white text-center">
                  PLEASE FILL THE FORM FOR ANY QUERY OR SUGGESTION
                </p>
                <Form>
                  <Form.Group className="mb-3" controlId="formFullName">
                    <Form.Control type="text" placeholder="FULL NAME" />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="formEmail">
                    <Form.Control type="email" placeholder="EMAIL ADDRESS" />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="formComment">
                    <Form.Control as="textarea" rows={3} placeholder="YOUR COMMENT" />
                  </Form.Group>

                  <Button
                    variant="warning1"
                    className="learn-more-btn rounded-pill px-4 py-2 w-100"
                    type="submit"
                  >
                    SUBMIT
                  </Button>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default WeddingInfo;
